<mat-form-field class="full-width">
	<mat-label>{{props.label}}</mat-label>
	<input matInput type="time" [formControl]="formControl" [formlyAttributes]="field" [errorStateMatcher]="matcher">
	<mat-error>{{getErrorMessage()}}</mat-error>
</mat-form-field>